import { create } from "zustand";

export interface ISmsVerificationInfo {
  phone: string;
  code: string;
}

interface SmsVerificationInfoStore {
  smsVerificationInfo: ISmsVerificationInfo;
  setSmsVerificationInfo: (smsVerificationInfo: ISmsVerificationInfo) => void;
}

export const useSmsVerificationInfoStore = create<SmsVerificationInfoStore>(
  (set) => ({
    smsVerificationInfo: {
      phone: "",
      code: "",
    },
    setSmsVerificationInfo: (smsVerificationInfo) =>
      set({ smsVerificationInfo }),
  })
);
